// Nav entry of Grammar (shell/nav.ts collects every routes/*.nav.ts; `order` places it in the rail, the tabs and Lisää).
// Kielioppi: the whole grammar on one page, open from day one (not gated by lesson unlocks).
import { defineNav } from '../shell/nav-entry';

export const nav = defineNav({ id: 'grammar', path: '/grammar', icon: 'grammar', group: 'learn', phone: 'more', order: 600, load: () => import('./Grammar') });
